import { render, staticRenderFns } from "./myshouyi.vue?vue&type=template&id=5b20e348&scoped=true"
import script from "./myshouyi.vue?vue&type=script&lang=js"
export * from "./myshouyi.vue?vue&type=script&lang=js"
import style0 from "./myshouyi.vue?vue&type=style&index=0&id=5b20e348&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b20e348",
  null
  
)

export default component.exports